import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController } from 'ionic-angular';
import { Api } from '../../providers/api';
import { ErrorResponse } from '../../providers/api/responses/ErrorResponse';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';

@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.html'
})
export class ChangePasswordPage {

    public password: string;
    public confirm: string;

    constructor(
        public api: Api,
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public loadingCtrl: LoadingController,
        public navCtrl: NavController,
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('ChangePassword');
    }

    public save() {
        if (!this.password) {
            return this.showError('New password cannot be blank');
        }

        if (this.password.length < 6) {
            return this.showError('New password must be at least 6 characters long');
        }

        if (this.password !== this.confirm) {
            return this.showError('The passwords you have entered do not match');
        }

        let loading = this.loadingCtrl.create();
        loading.present();

        this.api.postChangePassword({
            password: this.password
        }).finally(() => {
            loading.dismiss();
        }).subscribe(response => {
            if (response.success) {
                this.showAlert('Your password has been changed!', 'Success');
                this.navCtrl.pop();
            } else {
                this.showError('There was an error while attempting to change your password. Please try again.');
            }
        }, error => {
            if (error instanceof ErrorResponse) {
                this.showError(error.message);
            } else {
                this.showError('An unknown error has occured. Please try again.');
            }
        });
    }

    public showAlert(message: string, title: string) {
        let alert = this.alertCtrl.create({
            title: title,
            message: message,
            buttons: [{
                text: 'OK'
            }]
        });

        alert.present();
    }

    public showError(message: string) {
        this.showAlert(message, 'Error');
    }

}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.ts